import createDefaultFolderNodeViewState from '../utils/createDefaultFolderNodeViewState';
import FolderNodeViewState from '../store/schema/FolderNodeViewState';
import setMoveToFolderNodeViewState from '../actions/setMoveToFolderNodeViewState';
import { getStore } from '../store/Store';

/**
 * Selector function which returns
 * moveToFolderNodeViewState if already present in the store.
 * Adds default folderNodeViewState and returns if not present in the store.
 * @param folderId
 */
export default function getMoveToFolderNodeViewState(folderId: string): FolderNodeViewState {
    const store = getStore();
    if (!store.moveToFolderNodeViewStates.has(folderId)) {
        setMoveToFolderNodeViewState(folderId, createDefaultFolderNodeViewState());
    }
    return store.moveToFolderNodeViewStates.get(folderId);
}
